module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-hongkong.567b2dd0.png";